import React, { useState, useEffect } from "react";
import { IoMdContacts, IoMdDocument } from "react-icons/io";
import { ApiCall } from "../../../api/ApiCall";
import Payment from "../../../ConsultaionsForm/Payment";

import { useQuery } from "react-query";
import moment from "moment";
import {
  getAllConsultations,
  getConsultationCounts,
  getUnpaidConsultations,
} from "../../../api/index";
import ConsultationsData from "./ConsultationsData";
import { ReactSVG } from "react-svg";

function DashBoardTable(props) {
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalConsultations, setTotalConsultations] = useState(0);
  const [activeUnpaid, setActiveUnpaid] = useState(false);
  const [consultations, setConsultations] = useState([]);
  const [consultationsUnpaid, setConsultationsUnpaid] = useState([]);
  const [selectedConsultation, setSelectedConsultation] = useState();
  const [pubKeyStripe, setPubKeyStripe] = useState(null);

  const [show, setShow] = useState(false);
  const token = localStorage.getItem("token");

  const { isLoading } = useQuery(["dashboardCounts"], getConsultationCounts, {
    retry: 1,
    retryDelay: 500,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setTotalPaid(data?.data?.paid);
      setTotalConsultations(data?.data?.consultations);
    },
  });

  const {
    isLoading: loading,
    isFetching,
    data,
    isError,
  } = useQuery(["allConsultations"], getAllConsultations, {
    retry: 1,
    retryDelay: 500,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      // Define the order of status values
      const statusOrder = {
        declined: 0,
        new: 1,
        assigned: 2,
        completed: 3,
        unassigned: 4,
      };

      const paymentStatusOrder = {
        pending: 0,
        cofirmed: 1,
      };

      setConsultations(
        data?.data
          ?.filter((e) => e.paymentStatus == "confirmed")
          .sort((a, b) => statusOrder[a.status] - statusOrder[b.status])
      );
      setConsultationsUnpaid(
        data?.data?.filter((e) => e.paymentStatus == "pending")
      );
    },
  });

  let pubKeyResponse;
  useEffect(async () => {
    try {
      pubKeyResponse = await ApiCall({
        route: "payment/stripe-key",
        token: token,
        params: {},
        verb: "get",
        baseurl: true,
      });
      console.log(pubKeyResponse.response);
      setPubKeyStripe(pubKeyResponse?.response.stripeApiKey);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const removeCardFromArray = (id) => {
    setConsultationsUnpaid(consultationsUnpaid.filter((e) => e._id !== id));
  };

  const retryPaymentHandler = (consultation) => {
    setSelectedConsultation(consultation);
    setShow(true);
  };

  console.log(data?.data);
  // console.log(consultations.filter((e) => e.paymentStatus !== "pending"));

  return (
    <div>
      <div className="dash_title">Dashboard</div>
      <div class="amount">
        <div className="amountdiv">
          <div className="clramount">
            <IoMdContacts
              style={{ width: "89px", height: "66px", paddingTop: "17px" }}
            />
          </div>
          <div className="contentamount">
            <div className="total_text">Total Amount Paid</div>
            <div class="seven">{totalPaid}</div>
          </div>
        </div>
        <div className="amountdiv1">
          <div className="clrredamount">
            <IoMdDocument
              style={{ width: "89px", height: "66px", paddingTop: "17px" }}
            />
          </div>
          <div className="contentamount">
            <div className="total_text">Total Consultations</div>
            <div class="THREE">{totalConsultations}</div>
          </div>
        </div>
      </div>
      {consultationsUnpaid.length > 0 &&
        consultationsUnpaid.map((consultation) => {
          return (
            <div className="recent-pending-payment">
              <p
                className="payment-status-pending-error-mobile"
                style={{ fontSize: " 12px", color: " red" }}
              >
                {consultation?.consultationType === "written_report_analysis"
                  ? "Please pay to get consultation services for your report."
                  : "Please pay within 30 minutes after booking to confirm your slot."}
              </p>
              <div className="pending-payment-header">
                <h3 className="pending-payment-type">
                  {/* Consultation Type:{" "} */}
                  <span>
                    {consultation?.consultationType.replaceAll("_", " ")}
                  </span>
                </h3>
                {
                  <p
                    className="payment-status-pending-error"
                    style={{ fontSize: " 12px", color: " red" }}
                  >
                    {consultation?.consultationType ===
                    "written_report_analysis"
                      ? "Please pay to get consultation services for your report."
                      : "Please pay within 30 minutes after booking to confirm your slot."}
                  </p>
                }
                <ReactSVG
                  onClick={() => removeCardFromArray(consultation?._id)}
                  className="cross-button-svg"
                  src="/icons/tools/cross.svg"
                />
              </div>

              <div className="pending-payment-line">
                <div className="pending-payment-item">
                  <h6>Medical condition</h6>
                  <h4>{consultation?.medical?.replaceAll("_", " ")}</h4>
                </div>
                <div className="pending-payment-item">
                  <h6>Patient name</h6>
                  <h4>
                    {consultation?.firstName?.replaceAll("_", " ") +
                      " " +
                      consultation?.lastName?.replaceAll("_", " ")}
                  </h4>
                </div>{" "}
                {/* <div className="pending-payment-item">
                    <h6>Payment Status</h6>
                    <h4
                      className={
                        consultation?.paymentStatus == "pending"
                          ? "error"
                          : "success"
                      }
                    >
                      {consultation?.paymentStatus?.replaceAll("_", " ")}
                    </h4>
                  </div> */}
                {/* <div className="pending-payment-item">
                    <h6>Payable Amount</h6>
                    <h4>${consultation?.paidAmount?.replaceAll("_", " ")}</h4>
                  </div>{" "} */}
                <div className="pending-payment-item payment-item-date">
                  <h6>Booking Date</h6>
                  <h4>
                    {moment(consultation?.createdAt).format(
                      "MMMM Do YYYY, h:mm a"
                    )}
                  </h4>
                </div>
                {consultation?.consultationType !==
                  "written_report_analysis" && (
                  <div className="pending-payment-item payment-item-date">
                    <h6>Call Start Date</h6>
                    <h4>
                      {moment(consultation?.timeSlot?.startTime).format(
                        "MMMM Do YYYY, h:mm a"
                      )}
                    </h4>
                  </div>
                )}{" "}
                {/* {consultation?.consultationType !==
                    "written_report_analysis" && (
                    <div className="pending-payment-item">
                      <h6>Call End Date</h6>
                      <h4 className="payment-item-date">
                        {moment(consultation?.timeSlot?.startTime).format(
                          "MMMM Do YYYY, h:mm a"
                        )}
                      </h4>
                    </div>
                  )} */}
                {consultation?.consultationType ===
                  "written_report_analysis" && (
                  <div className="pending-payment-item comments-item">
                    <h6>Comments</h6>
                    <h4 className="comments">{consultation?.comment}</h4>
                  </div>
                )}{" "}
                <button
                  className="retry-payment-button"
                  onClick={() => retryPaymentHandler(consultation)}
                >
                  Retry Payment
                </button>
              </div>
              {/* {consultation?.consultationType !==
                  "written_report_analysis" && (
                  <div className="pending-payment-line">
                    <div className="pending-payment-item comments-item">
                      <h6>Comments</h6>
                      <h4>{consultation?.comment}</h4>
                    </div>
                  </div>
                )} */}
            </div>
          );
        })}

      <ConsultationsData consultations={consultations} loading={loading} />
      {show && (
        <Payment
          temp={
            selectedConsultation?.consultationType !== "written_report_analysis"
              ? { data: selectedConsultation }
              : selectedConsultation
          }
          consultationType={selectedConsultation?.consultationType}
          show={show}
          setStep={setShow}
          setShow={setShow}
          amount={selectedConsultation.paidAmount}
          price={selectedConsultation.paidAmount}
          pubKeyStripe={pubKeyStripe}
        />
      )}
    </div>
  );
}

export default DashBoardTable;
